import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AppSharedModule } from 'app/app-shared.module';
import { SmartSummaryFeedbackReport } from 'app/providers/storage-api/interactive-smart-summary.service';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-smart-summary-feedback-dialog',
  imports: [AppSharedModule],
  templateUrl: './smart-summary-feedback-dialog.component.html',
  styleUrls: ['./smart-summary-feedback-dialog.component.scss'],
})
export class SmartSummaryFeedbackDialogComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() currentFeedback?: SmartSummaryFeedbackReport;
  @Output() modalClosed = new EventEmitter<{ type: string; data: string }>();

  feedbackText = '';
  feedbackType: 'positive' | 'negative' | null = null;

  async ngOnInit() {
    this.feedbackType = this.currentFeedback?.feedbackType || 'negative';
    this.feedbackText = this.currentFeedback?.userFeedback || '';
    if (this.feedbackType !== 'positive' && this.feedbackType !== 'negative') {
      this.feedbackType = 'negative';
    }
  }

  onCancel(): void {
    this.modalClosed.emit();
  }

  onConfirm(): void {
    this.modalClosed.emit({ type: this.feedbackType, data: this.feedbackText });
  }
}
